import { render, staticRenderFns } from "./add-certificate.vue?vue&type=template&id=5418fb8e&scoped=true&"
import script from "./add-certificate.vue?vue&type=script&lang=js&"
export * from "./add-certificate.vue?vue&type=script&lang=js&"
import style0 from "./add-certificate.vue?vue&type=style&index=0&id=5418fb8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5418fb8e",
  null
  
)

export default component.exports